import "typesafe-actions";
import { extendedViewCleanDelay } from "../../redux-folder/view/types.js";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { validateCountry } from "./utils.js";
function useCountries({
  viewType,
  displayName,
  validateFilter,
  isCancelable,
  config,
  countryEntity
}) {
  const { items } = useViewInit({
    defaultFilters: [],
    viewType,
    displayName,
    entity: {
      entity: countryEntity,
      fields: ["iso2Code"]
    },
    validateFilter,
    cleanDelay: extendedViewCleanDelay,
    isCancelable
  });
  function getCountries() {
    return items?.filter((i) => i).filter((i) => validateCountry(i.iso2Code, config));
  }
  return { countries: getCountries() };
}
export {
  useCountries
};
//# sourceMappingURL=hooks.js.map
